const nivelEducativoOptions = [
  {
    label: 'Selecciona',
    value: ''
  },
  {
    label: 'Preescolar',
    value: 'Preescolar'
  },
  {
    label: 'Primaria',
    value: 'Primaria'
  },
  {
    label: 'Secundaria',
    value: 'Secundaria'
  },
  {
    label: 'Profesional técnico',
    value: 'Profesional técnico'
  },
  {
    label: 'Bachillerato o su equivalente',
    value: 'Bachillerato o su equivalente'
  },
];

export default nivelEducativoOptions;